import React from 'react';
import { IconPropsWithOrientation } from '../../icons';
import { SvgContainerWithOrientation } from '../../Icons.styles';

const ORIENTATION_MAP = {
  up: 'rotate(0deg)',
  down: 'rotate(180deg)',
  left: 'rotate(-90deg)',
  right: 'rotate(90deg)',
};

const SvgContainer = SvgContainerWithOrientation(ORIENTATION_MAP);

const Chevron = ({
  width = 25,
  orientation = 'up',
  color = 'var(--text-primary)',
  className = '',
}: IconPropsWithOrientation): JSX.Element => {
  return (
    <SvgContainer
      className={className}
      $orientation={orientation}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M18 15L12 9L6 15'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgContainer>
  );
};

export default Chevron;
